module.exports = __webpack_public_path__ + "static/media/gol-js.f926fbf5.png";